import { render, staticRenderFns } from "./StockBatchMovement.vue?vue&type=template&id=a4ddf840&"
import script from "./StockBatchMovement.vue?vue&type=script&lang=js&"
export * from "./StockBatchMovement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports